import './sticky-cta.scss';

import { getOffset, smoothScrollTo } from './../../utilities/js/helper';

class StickyCta {
    constructor (el) {
        this.stickyCTA = el;
        this.fixedCTA = el.querySelector('[data-sticky-cta="fixed"]');
        this.scrollToCTA = el.querySelectorAll('[data-anchor-scroll-to]');
        this.triggerCTA = document.querySelector('[data-sticky-cta="trigger"]');

        this.options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.scrollToCTA.forEach($currentItem => {
            const scrollToTarget = () => {
                const targetId = $currentItem.getAttribute('href').split('#')[1];
                const $target = document.getElementById(targetId);

                if ($target !== null) {
                    const anchorDimensions = getOffset($target);
                    const anchorDimensionsTop = anchorDimensions.top;

                    setTimeout(() => {
                        smoothScrollTo(0, anchorDimensionsTop - 185, 400);
                    }, 150);
                }
            };

            $currentItem.addEventListener('click', (e) => {
                scrollToTarget();
                e.preventDefault();
            });

            $currentItem.addEventListener('keydown', (e) => {
                if (e.code === 'Space' || e.code === 'Enter') {
                    scrollToTarget();
                }
            });
        });

        if (this.triggerCTA && this.fixedCTA) {
            this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.options);
            this.observer.observe(this.triggerCTA);
        } else {
            this.observer = new IntersectionObserver(this.handleIntersection.bind(this), this.options);
            this.observer.observe(this.stickyCTA);
        }
    }

    handleIntersection (entries) {
        entries.forEach(entry => {
            this.stickyCTA.setAttribute('data-sticky-cta-visible', entry.isIntersecting);
        });
    }
}

export { StickyCta };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$stickyCta = $context.querySelectorAll('[data-sticky-cta="root"]') || [];

        $$stickyCta.forEach(($stickyCta) => {
            const stickyCta = new StickyCta($stickyCta); // eslint-disable-line
        });
    }
});
